import { useEffect, useState, type ReactNode } from 'react';

type IdleWindow = Window & {
  requestIdleCallback?: (cb: () => void, opts?: { timeout?: number }) => number;
  cancelIdleCallback?: (handle: number) => void;
};

export default function DeferredBoot({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const w = window as IdleWindow;
    let idleHandle: number | null = null;
    let timeoutHandle: number | null = null;

    if (typeof w.requestIdleCallback === 'function') {
      idleHandle = w.requestIdleCallback(() => setReady(true), { timeout: 2000 });
    } else {
      timeoutHandle = window.setTimeout(() => setReady(true), 200);
    }

    return () => {
      if (idleHandle != null && typeof w.cancelIdleCallback === 'function') {
        w.cancelIdleCallback(idleHandle);
      }
      if (timeoutHandle != null) {
        window.clearTimeout(timeoutHandle);
      }
    };
  }, []);

  return ready ? <>{children}</> : null;
}
